import { modelAuthLoginResponse, modelAuthRequestOtpResponse } from '@shared-core/features/auth/models'
import { CAPTCHA_RETRYABLE_ERRORS } from '@shared-core/services/api/captcha'
import { makeAPI } from '@shared-core/services/api/client'

export const apiLoginTma = makeAPI<typeof modelAuthLoginResponse, { data: { init_data_raw: string } }>({
  method: 'post',
  parser: modelAuthLoginResponse,
  url: '/api/v1/auth/tma',
})

export const apiRequestAuthOtp = makeAPI<
  typeof modelAuthRequestOtpResponse,
  { data: { phone: string; captchaToken?: string } }
>({
  method: 'post',
  parser: modelAuthRequestOtpResponse,
  url: '/api/v1/auth/phone',
  silentErrorCodes: CAPTCHA_RETRYABLE_ERRORS,
})

export const apiLoginByPhoneOtp = makeAPI<typeof modelAuthLoginResponse, { data: { phone: string; otp: string } }>({
  method: 'post',
  parser: modelAuthLoginResponse,
  url: '/api/v1/auth/phone/verify',
  silentErrorCodes: ['CODE_INVALID_OR_EXPIRED', 'INVALID_CODE'],
  silentErrorStatuses: [404, 406],
})

export const apiRefreshAuthTokens = makeAPI<typeof modelAuthLoginResponse, { data: { refreshToken: string } }>({
  method: 'post',
  parser: modelAuthLoginResponse,
  url: '/api/v1/auth/refresh_tokens',
})
